import React, { useState } from 'react';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField, Popover, Box, IconButton } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import InputAdornment from '@mui/material/InputAdornment';
import { format } from 'date-fns';

const TwoMonthDatePicker = ({ value, onChange, label, disabled, error, minDate, maxDate, helperText, variant = 'standard', sx, InputLabelProps, singleMonth = true, ...rest }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [tempValue, setTempValue] = useState(null);
  const open = Boolean(anchorEl) && !disabled;

  const handleOpen = (e) => {
    if (!disabled) {
      setTempValue(value);
      setAnchorEl(e.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setTempValue(null);
  };

  const handleDateSelect = (date) => {
    onChange(date);
    setAnchorEl(null);
    setTempValue(null);
  };

  const displayValue = value ? format(value, 'dd/MM/yyyy') : '';

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TextField
        label={label}
        value={displayValue}
        onClick={handleOpen}
        variant={variant}
        error={error}
        helperText={helperText}
        InputLabelProps={InputLabelProps}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton size="small" onClick={handleOpen} disabled={disabled}>
                <CalendarTodayIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        disabled={disabled}
        sx={{
          '& .MuiInput-underline:after': { borderBottomColor: '#800040' },
          '& .MuiInput-underline:before': { borderBottomColor: '#ccc' },
          '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#800040' },
          ...sx,
        }}
        {...rest}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        disableAutoFocus
        disableEnforceFocus
      >
        <Box sx={{ p: 2 }}>
          <DateCalendar
            value={tempValue}
            onChange={handleDateSelect}
            views={['day']}
            minDate={minDate}
            maxDate={maxDate}
            sx={singleMonth ? {} : undefined}
          />
        </Box>
      </Popover>
    </LocalizationProvider>
  );
};

export default TwoMonthDatePicker;
